export const conversionReportCardProps = {
    conversions: {
        id: "conversions",
        num: "1",
        title: "Conversions",
        description: "Конверсии",
        list: ["Просмотр всех конверсионных тегов", "Первичный мониторинг результатов"],
        cardLink: "/conversions",
    },
    conversionTags: {
        id: "conversion-tags",
        num: "2",
        title: "Conversions report",
        description: "Отчет по\u00A0конверсиям и\u00A0конверсионным тегам",
        list: ["С привязкой к\u00A0рекламным кампаниям", "Без привязки к\u00A0рекламным кампаниям"],
        cardLink: "/conversion-tags",
    },
    setConversionTags: {
        id: "setConversionTags",
        num: "3",
        title: "Set conversion tags",
        description: "Инструкция по\u00A0установке конверсионных тегов",
        list: ["Через вёрстку сайта", "Через Яндекс Тег Менеджер"],
        cardLink: "/setConversionTags",
    }
};
